<script>
  import { mapState } from 'vuex'
  import HitPostBar from '@/components/Hit/HitPostBar'
  import ModalBase from './ModalBase'
  import ModalHitForm from './ModalHitForm'
  import ModalSocialLinks from './ModalSocialLinks'
  import ModalEditProfile from './ModalEditProfile'
  import ModalEditAlternativeEmail from './ModalEditAlternativeEmail'

  export default {
    components: {
      HitPostBar,
      ModalBase,
      ModalHitForm,
      ModalSocialLinks,
      ModalEditProfile,
      ModalEditAlternativeEmail
    },

    computed: {
      ...mapState({
        modals: state => state.Modals
      })
    },

    methods: {
      modalHide(modal_name) {
        this.$store.commit('Modals/hide', modal_name)
      }
    }
  }
</script>

<template>
  <div class="Modals">
    <modal-base class="Modals_hpb" :open="modals.hit_post_bar" @close="modalHide('hit_post_bar')">
      <div class="modal-content">
        <hit-post-bar />
      </div>
      <button class="modal-close" @click="modalHide('hit_post_bar')"></button>
    </modal-base>

    <modal-base :open="modals.edit_profile" @close="modalHide('edit_profile')">
      <modal-edit-profile />
    </modal-base>

    <modal-base :open="modals.social_links" @close="modalHide('social_links')">
      <modal-social-links />
    </modal-base>

    <modal-base :open="modals.hit_image" @close="modalHide('hit_image')">
      <modal-hit-form type="IMAGE" />
    </modal-base>
    <modal-base :open="modals.hit_code" @close="modalHide('hit_code')">
      <modal-hit-form type="CODE" />
    </modal-base>
    <modal-base :open="modals.hit_video" @close="modalHide('hit_video')">
      <modal-hit-form type="VIDEO" />
    </modal-base>
    <modal-base :open="modals.hit_link" @close="modalHide('hit_link')">
      <modal-hit-form type="LINK" />
    </modal-base>

    <modal-base :open="modals.edit_alternative_email" @close="modalHide('edit_alternative_email')">
      <modal-edit-alternative-email />
    </modal-base>
  </div>
</template>

<style lang="scss">
  .Modals {
    position: absolute;
    z-index: 1000;

    &_hpb .modal-content {
      overflow: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// AllModals.vue?9ebc710a